// Normal Order
export const ALL_SALES_REQUEST = "ALL_SALES_REQUEST";
export const ALL_SALES_SUCCESS = "ALL_SALES_SUCCESS";
export const ALL_SALES_FAIL = "ALL_SALES_FAIL";

// Shop Order
export const ALL_SHOP_ORDER_SALES_REQUEST = "ALL_SHOP_ORDER_SALES_REQUEST";
export const ALL_SHOP_ORDER_SALES_SUCCESS = "ALL_SHOP_ORDER_SALES_SUCCESS";
export const ALL_SHOP_ORDER_SALES_FAIL = "ALL_SHOP_ORDER_SALES_FAIL";
